export const mobileSessionActionTypes = {
  SET_DID_VISIT_MOBILE_EDITOR_IN_CURRENT_SESSION_TRUE:
    'set-did-visit-mobile-editor-in-current-session-true',
} as const;

export type MobileSessionActionTypes = ValueOf<typeof mobileSessionActionTypes>;
